import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type {
  HandlersBulkMessageSimsResponse,
  StructsDataMessage,
  StructsSocketMessage,
} from 'types/__generated__/SimInventoryApi';
import type { HologramSimIdsMap } from 'types/common';

interface UseBulkSendSocketMessageCallProps {
  sims: HologramSimIdsMap;
  port: string;
  encrypted?: boolean;
  protocol?: StructsDataMessage;
}

interface SendSocketMessageCallbackBodyProps extends UseBulkSendSocketMessageCallProps {
  body?: string;
}
interface SendSocketMessageCallbackBodyBase64Props extends UseBulkSendSocketMessageCallProps {
  base64body?: string;
}

type AllProps = SendSocketMessageCallbackBodyProps & SendSocketMessageCallbackBodyBase64Props;

type ReturnVal = Promise<HandlersBulkMessageSimsResponse | undefined>;

const useBulkSendSocketMessageCall = () => {
  const url = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/message/socket`;

  const callback = useCallback<
    (
      props: SendSocketMessageCallbackBodyProps | SendSocketMessageCallbackBodyBase64Props
    ) => ReturnVal
  >(
    async (props: AllProps): ReturnVal => {
      if (!url) {
        return undefined;
      }
      const { sims, body, base64body, encrypted, port, protocol } = props;

      const postBody: StructsSocketMessage = {
        encrypted,
        port,
        protocol,
        hologramSimIds: [...sims.keys()],
      };

      if (body) {
        postBody.data = body;
      } else if (base64body) {
        postBody.base64data = base64body;
      }

      const result: HandlersBulkMessageSimsResponse | undefined = await postFetcher({
        url,
        body: postBody,
      });

      return result;
    },
    [url]
  );

  return callback;
};

export default useBulkSendSocketMessageCall;
